import React, { useEffect, useState, useMemo, useRef } from 'react';
import { Icon, ICONS, useTheme, Loader, CustomTable, Pagination, Search, Select, SuccessModal } from '@ohif/ui';
import Modal from '@custom/Reports/reportModal';
import Header from '../Header/Header';
import { useNavigate } from 'react-router-dom';
import { _routes } from '@custom/Utils/constants/routes';
import { DatePickerWithRange } from '@ohif/ui-next';
import { calculateAge, customStyle, formatDate } from '@custom/Utils/utils';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@custom/store/store';
import fetchReviewList from '@custom/rtk-apis/myworklist/myworkList';
import sendBackReport from '@custom/rtk-apis/myworklist/sendBackreport';
import { resetSendBackReportState } from '@custom/store/slices/myworklist/sendBackSlice';
import { resetReviewState } from '@custom/store/slices/radiologiestUser/sendReviewSlice';
import { Form, Formik } from 'formik';
import { apiRequest } from '@custom/Utils/config/apiRequest';
import { _commonUrls } from '@custom/Utils/constants/apiUrls';
import saveProcessedReportsApi from '@custom/rtk-apis/report/saveProcessedReport';

const MyworkList = props => {
  const dispatch = useDispatch<AppDispatch>();
  const [successPopup, setSuccessPopup] = useState({
    title: "",
    status: false
  });
  const [statusFilter, setStatusFilter] = useState({
    selectedOptions: '',
    actions: '',
  });
  const reviewDataResponse = useSelector((state: RootState) => state.reviewSliceResponce);
  const sendBackResponce = useSelector((state: RootState) => state.sendBackSliceResponce);
  const { status, result, msg, loading, error } = useSelector((state: RootState) => state.saveProcessedReportsResponse);
  const isLoading = reviewDataResponse?.loading || sendBackResponce?.loading;
  const [pgNumber, setPgNumber] = useState(1);
  const [pgLimit, setPgLimit] = useState(30);
  const [searchQuery, setSearchQuery] = useState('');
  const [search, setSearch] = useState('');
  const [searchInputValue, setSearchInputValue] = useState('');
  const [selectedCount, setSelectedCount] = useState(0);
  const formikRef = useRef(null);
  const buttonRef = useRef(null);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const toggleFilter = () => {
    setIsFilterOpen(!isFilterOpen);
  };
  const [filterData, setFilterData] = useState({
    status: [],
  })
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [dateRange, setDateRange] = useState<{
    startDate: string | null;
    endDate: string | null
  }>({
    startDate: null,
    endDate: null
  });
  const [reportStatusList, setReportStatusList] = useState([]);

  useEffect(() => {
    const hospitalId = sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');

    if (reviewDataResponse?.status === 'SUCCESS') {
      const reportIds = reviewDataResponse?.reviewdata?.map(item => item._id) || [];

      dispatch(saveProcessedReportsApi({
        reportId: reportIds,
        hospitalId: hospitalId
      }))
        .unwrap()
        .then((response) => {
          console.log('Reports processed successfully:', response);
        })
        .catch((error) => {
          console.error('Error processing reports:', error);
        });
    }
  }, [reviewDataResponse?.status]);

  const getFormatDate = (dateString) => {
    if (dateString.length !== 8) {
      return '';
    }
    const day = dateString?.slice(0, 2);
    const month = dateString?.slice(2, 4);
    const year = dateString?.slice(4, 8);
    return `${year}-${month}-${day}`;
  };

  const fetchReviews = (fromDate?: string, toDate?: string) => {
    const selectedStatus = filterData.status.length > 0 ? filterData.status : undefined;
    dispatch(fetchReviewList({
      limit: pgLimit,
      pageNumber: pgNumber,
      search: searchQuery,
      status: selectedStatus,
      fromDate: fromDate ? getFormatDate(fromDate) : (startDate ? getFormatDate(startDate) : ''),
      toDate: toDate ? getFormatDate(toDate) : (endDate ? getFormatDate(endDate) : ''),
    }));
  };

  useEffect(() => {
    fetchReviews();
  }, [filterData.status, searchQuery, pgLimit, pgNumber, startDate, endDate]);

  useEffect(() => {
    if (reviewDataResponse?.status === 'SUCCESS') {
      let tempArray = []
      reviewDataResponse?.reviewdata?.map((item) => {
        const userToFind = sessionStorage.getItem("userId")
        const user = item?.reviewerDetail?.find(item => item.userId === userToFind);
        console.log('reviewerDetail', item, user);
        tempArray.push({
          ...item,
          name: item?.name
            ? item.name
              .split(' ')
              .map(word => word.charAt(0).toUpperCase() + word.slice(1))
              .join(' ')
            : '--',
          date: formatDate(item?.date) || "--",
          age: calculateAge(item.age || 0) || "--",
          status: item?.status ==='Sent for Review' ? item?.oldStatus : item?.status || "--"
        })
      })
      setList(tempArray)
    }
  }, [reviewDataResponse])

  const handleSendBack = ({ reportId: reportId }) => {
    dispatch(sendBackReport({ reportId: reportId }));
  };

  useEffect(() => {
    if (sendBackResponce?.status === 'SUCCESS') {
      setSuccessPopup({
        title: sendBackResponce?.message,
        status: true
      })
    }
    setTimeout(() => {
      setSuccessPopup({
        title: "",
        status: false
      })

      dispatch(resetSendBackReportState());
      setTimeout(() => {
        fetchReviews();
      }, 0);
    }, 1000)
  }, [dispatch, sendBackResponce?.status])

  const [list, setList] = useState([]);
  const [filterValue, setFilterValue] = useState({
    Status: "",
    Date: {
      startDate: "",
      endDate: ""
    }
  });

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [selectedReport, setSelectedReport] = useState({});
  const name = sessionStorage.getItem('name') || localStorage.getItem('name');

  const [authorize, setAuthorize] = useState(false);
  const [isConfirmingAuthorize, setIsConfirmingAuthorize] = useState(false);
  const [isReportComplete, setReportComplete] = useState(false);
  const [isAuthorized, setIsAuthorized] = useState(false);
  const navigate = useNavigate()
  const { isDarkMode } = useTheme();

  // const { resultsPerPage, pageNumber, sortBy, sortDirection } = filterValue;
  const searchClick = searchText => {
    setSearchQuery(searchText);
    setSearchInputValue(searchText);
  };

  const handleDateChange = (dates: { startDate: string, endDate: string }) => {
    const { startDate, endDate } = dates;

    if (startDate && endDate) {
      setDateRange({ startDate, endDate });
      setStartDate(startDate);
      setEndDate(endDate);
      setPgNumber(1);
    }
  };

  useEffect(() => {
    fetchCommonData()
  }, []);

  const fetchCommonData = async () => {
    try {
      const commonData: any = await apiRequest({ method: 'POST', endUrl: _commonUrls.list, body: {}, headerType: 'json' })
      if (commonData?.status) {
        let data = commonData?.result?.reportListStatus;
        data = data.filter(item => item.value !== "Sent");
        const index = data.findIndex(item => item.value === "Confirmed");
        if (index !== -1) {
          data.splice(index, 1);
        };
        data.push({ value: "Reviewed", label: "Reviewed" });
        setReportStatusList(data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const resetFilter = () => {
    setStartDate("");
    setEndDate("");
    setStatusFilter({
      selectedOptions: '',
      actions: ''
    });
    setDateRange({
      startDate: null,
      endDate: null
    });
    setSearch("");
    setSearchInputValue("");
    setPgNumber(1);
    setFilterData({
      status: [],
    });
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
  };

  const filterFormInitialValue = {
    status: filterData?.status || [],
  }

  const handleFieldChange = newValue => {
    setFilterValue(prevValues => ({
      ...prevValues,
      Status: newValue
    }))
  }
  const tableColumn = [
    { key: 'name', title: 'Name', sort: true },
    { key: 'age', title: 'Age', sort: true },
    { key: 'gender', title: 'Gender' },
    { key: 'modality', title: 'Modality', sort: true },
    { key: 'studyRegion', title: 'Study Region', sort: true },
    { key: 'date', title: 'Date' },
    { key: 'patientId', title: 'Patient ID' },
    { key: 'uhid', title: 'UHID' },
    { key: 'status', title: 'Status' },
    { key: 'actions', title: 'Action' }
  ];
  const actions = [
    {
      label: 'Edit',
      iconName: 'edit',
      onClick: ((item) => {
        setSelectedReport(item);
        setIsModalOpen(true);
        setEditMode(true);
      })
    },
    {
      label: 'Complete',
      iconName: 'confirm',
      onClick: ((item) => {
        if (item.status === 'Draft') {
          handleComplete(item)
          setEditMode(false);
        }
        else if (item.status === "Sent for Review") {
          handleComplete(item)
          setEditMode(false);
        }
        else if (item.status === "Completed") {
          handleAuthorize(item)
          setEditMode(false);
        }
      })
    },
    {
      label: "Authorize",
      iconName: 'confirm',
      onClick: ((item) => {
        let selectedData = item
        selectedData.status = 'Completed'
        handleAuthorize(selectedData)
        setEditMode(false);
      })
    },

    {
      label: 'Preview',
      iconName: 'preview',
      onClick: ((item) => {
        navigate(_routes.report.previewWithId(item._id))
      })
    },
    {
      label: 'Send Back',
      iconName: 'review',
      onClick: ((item) => {
        handleSendBack({ reportId: item?._id });
      })
    },
    {
      label: 'View Images',
      iconName: 'viewImage',
      onClick: ((item) => {
        handleViewImage(item.studyInstanceUID)
      })
    }
  ];


  const handleViewImage = (studyInstanceUID: any) => {
    navigate(`/viewer?StudyInstanceUIDs=${studyInstanceUID}&action=review_report`)
  }

  const getActionAccordingToRole = (actions) => {
    const role = sessionStorage.getItem('name') || localStorage.getItem('name');
    if (role === 'Front Desk' || role === 'Nurse') {
      const action = actions.filter(action => action.label === 'Preview');
      return action
    }
    else {
      return actions
    }
  }

  const rollingPageNumberMod = Math.floor(101 / pgLimit);
  const rollingPageNumber = (pgNumber - 1) % rollingPageNumberMod;
  const offset = pgLimit * rollingPageNumber;

  const handlePageSizeChange = e => {
    setPgLimit(e);
  };

  const onPageChangeHandler = pg => {
    setPgNumber(pg);
  };

  const searchHandler = () => {

  }

  const handleAuthorize = (report) => {
    setSelectedReport(report);
    setIsModalOpen(true);
    setAuthorize(true);
  }

  const handleComplete = (report) => {
    setAuthorize(false);
    setSelectedReport(report);
    setIsModalOpen(true);
  }

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setAuthorize(false);
    setIsAuthorized(false);
    setSelectedReport(null);
  };

  useEffect(() => {
    searchHandler();
  }, [filterValue]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedReport(prevState => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {

    setAuthorize(false);

  }, [isAuthorized]);


  useEffect(() => {
    setAuthorize(false);
    setIsAuthorized(false);
  }, [isConfirmingAuthorize]);

  const handleSave = () => {

    const updatedReport = {
      ...selectedReport,
      status: "Completed",
    };
  };

  const handleAuthorizeComplete = () => {

  };

  const handleSaveForm = (values) => {
    setFilterData(values);
    setPgNumber(1);
    setIsFilterOpen(false);
    const selectedStatusCount = values.status ? values.status.length : 0;
    const selectedModalityCount = values.modality ? values.modality.length : 0;
    const totalSelectedCount = selectedStatusCount + selectedModalityCount;
    setSelectedCount(totalSelectedCount);
  }

  const handleResetForm = () => {
    setFilterData({
      status: [],
    });
    setStatusFilter({
      selectedOptions: '',
      actions: ''
    });
    setIsFilterOpen(false);
    setSelectedCount(0);
    if (formikRef.current) {
      formikRef.current.resetForm();
      formikRef.current.setFieldValue('status', []);
    }
  };

  const handleCancel = () => {
    handleCloseModal();
  };
  const cancelRichTextEditor = () => {
    setIsModalOpen(false)
    fetchReviews()
  }
  return (
    <>
      <div className='page page__fullBody' style={
        isDarkMode ? { background: '#090c29' } : customStyle.mainBackground
      }>
        <Header title='My Worklist'></Header>
        <div className='page__body'>
          <div className='tableWrap'>
            <div className='tableWrap__head'>
              <div className="formRow formRow__3 m_0 w_100 formRow--flexEnd">
                <div className='formCol'>
                  <Search text="Name" onSearchClick={searchClick} value={searchInputValue} setValue={setSearchInputValue}></Search>
                </div>
                <div className='formCol'>
                  <DatePickerWithRange
                    className=" px-4 py-1 rounded h-10"
                    onChange={handleDateChange}
                    startPlaceholder="From"
                    endPlaceholder="Now"
                    id="datepicker"
                    startDate={dateRange.startDate}
                    endDate={dateRange.endDate}
                    style={{ width: '200px' }}
                  />
                </div>
                <div className="formCol" style={{ position: 'relative' }}>
                  {selectedCount > 0 && (
                    <span className="badge absolute top-0 left-0 translate-x-1/2 translate-y-1/2">
                      {selectedCount}
                    </span>
                  )}
                  <button ref={buttonRef} onClick={toggleFilter} className="filter-button">
                    <span className='filterIcon'>
                      <img src={ICONS.filterIcon} alt="down arrow" />
                    </span>
                    Filter
                  </button>
                  <button onClick={resetFilter} className="filter-button">
                    <span className='filterIcon'>
                      <Icon name="ClearFilters" className="text-black cursor-pointer" width="16" height="16"></Icon>
                    </span>
                    Clear
                  </button>
                  {isFilterOpen && (
                    <div
                      className="filter-popup"
                      style={{
                        position: 'absolute',
                        top: buttonRef.current.offsetHeight + 10,
                        left: 0,
                        zIndex: 100,
                        backgroundColor: "#ffffff",
                        padding: '16px',
                        borderRadius: "16px",
                        width: "360px",
                        boxShadow: '0px 4px 20px 0px rgba(0, 0, 0, 0.16)',
                      }}
                    >
                      <Formik
                        key={JSON.stringify(filterData)}
                        initialValues={filterFormInitialValue}
                        onSubmit={(values, { setSubmitting }) => {
                          handleSaveForm(values);
                          setSubmitting(false);
                          setIsFilterOpen(false);
                          const selectedOptionsCount = values.status ? values.status.length : 0;
                          setSelectedCount(selectedOptionsCount);
                          handleFieldChange(values.status);
                        }}
                      >
                        {({ values, setFieldValue, handleSubmit }) => (
                          <Form onSubmit={handleSubmit}>
                            <div className='formRow'>
                              <div className='formCol'>
                                <div className='form__Field'>
                                  <label htmlFor='status' className="form__label">Status</label>
                                <Select
                                  id='status'
                                  placeholder='Select'
                                  className='custom-bg-white'
                                  isMulti={true}
                                  isClearable={false}
                                  isSearchable={true}
                                  closeMenuOnSelect={false}
                                  hideSelectedOptions={false}
                                  options={reportStatusList}
                                  value={values.status}
                                  onChange={(selectedOptions, action) => {
                                    setFieldValue('status', selectedOptions);
                                    setStatusFilter({ selectedOptions, actions: action });
                                  }}
                                />
                                </div>
                              </div>
                            </div>

                            <div className='filter-bottom'>
                              <button
                                type="submit"
                                className='custom-button main-theme mr-2'
                              >
                                Apply
                              </button>
                              <button type="button" className='custom-button' onClick={handleResetForm}>Clear</button>
                            </div>
                          </Form>
                        )}
                      </Formik>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className='tableContainer'>
              {isLoading ? <Loader isLoaderOpen={isLoading} /> : <CustomTable columns={tableColumn} data={list} actions={getActionAccordingToRole(actions)} searchQuery={searchQuery} from="reviewReport" />}
            </div>
          </div>
        </div>
        {list.length > 0 && <Pagination
          onChangePage={onPageChangeHandler}
          onChangePerPage={handlePageSizeChange}
          totalPage={list.length}
          currentPage={pgNumber}
          perPage={pgLimit}
        />}
        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            editMode={editMode}
            title={
              editMode
                ? "Edit Report"
                : (isConfirmingAuthorize
                  ? ""
                  : (authorize)
                    ? "Authorize Report"
                    : isAuthorized
                      ? "Authorize Report!"
                      : "Complete Report")
            }
            onClose={handleCloseModal}
            closeButton={true}
            containerDimensions="80vw, 80vh, 80vh,80vh"
            onSave={handleSave}
            onAuthorize={handleAuthorizeComplete}
            onCancel={handleCancel}
            setIsConfirmingAuthorize={setIsConfirmingAuthorize}
            setReportComplete={setReportComplete}
            setIsAuthorized={setIsAuthorized}
            setSelectedReport={setSelectedReport}
            handleInputChange={handleInputChange}
            selectedReport={selectedReport}
            isAuthorized={isAuthorized}
            isConfirmingAuthorize={isConfirmingAuthorize}
            getReports={getReports}
            setIsModalOpen={cancelRichTextEditor}
            updateReportInformation={''}
          >
            {isConfirmingAuthorize ? (
              <SuccessConfirmationModal
                handleCloseModal={handleCloseModal}
                setIsConfirmingAuthorize={setIsConfirmingAuthorize}
                title="Report Authorized Successfully!"
              />
            ) : isAuthorized && (
              <p style={{
                fontWeight: 400,
                lineHeight: '20px',
                textAlign: 'left',
                // background: '#150823',
                color: 'black',
                padding: '20px',
                paddingLeft: '18px',
                borderRadius: '8px',
              }}>
                Are you sure you want Authorize this report?
              </p>
            )}
          </Modal>
        )}

      </div>
      {successPopup.status && (
        <SuccessModal
          isSuccessModalOpen={successPopup.status}
          handleCloseModal={handleCloseModal}
          title={`${successPopup.title}.`}
        />
      )}
    </>
  );
};

export const SuccessConfirmationModal = ({ handleCloseModal, setIsConfirmingAuthorize, title }) => {
  setTimeout(() => {
    handleCloseModal(); // Call your function to close the modal
    setIsConfirmingAuthorize(false);
  }, 1500)
  return (
    <>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '200px',
          height: '100%',
          textAlign: 'center',
          borderRadius: '32px',
          padding: '10px 10px 0px 10px',
        }}>
        <Icon
          //onClick={onClose}
          name="SuccessCircle"
          className="text-black cursor-pointer"
        />
      </div>
      <p style={{
        fontFamily: 'Poppins, sans-serif',
        fontSize: '23.14px',
        fontWeight: 600,
        lineHeight: '34.71px',
        textAlign: 'center',
        // background: '#150823',
        color: 'black',
        padding: '0px 20px 60px 20px',
        borderRadius: '8px',
        marginTop: '0px',
      }}>
        {title}
      </p>
    </>
  )
}

export default MyworkList;
